import React, { FC } from 'react';
import cn from 'classnames';

type Props = {
  size: 'sm' | 'md';
  adjustPosition?: boolean;
  playAnimation?: boolean;
};

const Arrow: FC<Props> = ({
  size,
  adjustPosition = true,
  playAnimation = true,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    preserveAspectRatio="xMinYMin meet"
    className={cn(
      playAnimation ? 'arrow_wrapper' : 'animated-arrow--finished',
      'absolute top-0 rounded-full block stroke-5 stroke-white z-20 -mt-8 -mr-8',
      adjustPosition ? 'right-15' : 'right-0',
      size === 'sm' && 'w-15 h-15',
      size === 'md' && 'w-20 h-20 md:w-15 md:h-15',
    )}
  >
    <circle
      className="arrow__circle stroke-2 stroke-blue-light"
      cx="10"
      cy="10"
      r="10"
      fill="#1E78E8"
    />
    <path
      className="arrow__arrow"
      d="M10.2499 15H9.74993C9.61185 15 9.49993 14.8881 9.49993 14.75V6.665L7.27993 8.89C7.23298 8.93733 7.16909 8.96395 7.10243 8.96395C7.03577 8.96395 6.97187 8.93733 6.92493 8.89L6.57493 8.535C6.5276 8.48806 6.50098 8.42416 6.50098 8.3575C6.50098 8.29084 6.5276 8.22694 6.57493 8.18L9.63993 5.11C9.71018 5.03965 9.8055 5.00009 9.90493 5H10.0949C10.1941 5.00115 10.2891 5.04056 10.3599 5.11L13.4249 8.18C13.4723 8.22694 13.4989 8.29084 13.4989 8.3575C13.4989 8.42416 13.4723 8.48806 13.4249 8.535L13.0699 8.89C13.0238 8.93703 12.9608 8.96354 12.8949 8.96354C12.8291 8.96354 12.766 8.93703 12.7199 8.89L10.4999 6.665V14.75C10.4999 14.8881 10.388 15 10.2499 15Z"
      fill="white"
      stroke="white"
      strokeWidth="0.4"
    />
  </svg>
);

export default Arrow;
